module.exports = __webpack_public_path__ + "static/media/icon_select_num.2bcc84f0.svg";